// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.galleryMobile__container {
  position: relative;
  z-index: 1;
  width: 100vw;
  padding: 60px 0 10px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1px;
  font-weight: 300;
  letter-spacing: 2px;
}
.galleryMobile__container .galleryMobile__socialsSpacer {
  width: 100vw;
  height: 45px;
}
.galleryMobile__container .galleryMobile__imageContainer .galleryMobile__imageLoading {
  width: calc(100vw - 30px);
  height: 100vw;
  margin-top: 15px;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.galleryMobile__container .galleryMobile__imageContainer .galleryMobile__imageError {
  font-size: 32px;
  color: firebrick;
  width: calc(100vw - 30px);
  height: 100vw;
  margin-top: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.galleryMobile__container .galleryMobile__imageContainer .galleryMobile__imageError .galleryMobile__textError {
  color: white;
  margin-top: 10px;
  width: 150px;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 5px;
  opacity: 0.75;
}
.galleryMobile__container .galleryMobile__imageContainer .galleryMobile__image {
  width: calc(100vw - 30px);
  height: 100vw;
  margin-top: 15px;
  opacity: 1;
  object-fit: cover;
  object-position: 100% center;
  cursor: pointer;
  transition: height 0.6s ease, opacity 0.6s ease, margin 0.6s ease;
}
.galleryMobile__container .galleryMobile__imageContainer .galleryMobile__imageSensible {
  margin: 0;
  height: 0;
  opacity: 0;
  transition: height 0.6s ease, opacity 0.6s ease, margin 0.6s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/Gallery/GalleryMobile.less"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAZA;EAeQ,YAAA;EACA,YAAA;AAAR;AAhBA;EAsBY,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AAHZ;AA5BA;EAmCY,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,0CAAA;AAJZ;AA1CA;EAgDgB,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAHhB;AAnDA;EA2DY,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,iEAAA;AALZ;AA7DA;EAsEY,SAAA;EACA,SAAA;EACA,UAAA;EACA,iEAAA;AANZ","sourcesContent":["\n.galleryMobile__container{\n    position: relative;\n    z-index: 1;\n    width: 100vw;\n    padding: 60px 0 10px 0;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 1px;\n    font-weight: 300;\n    letter-spacing: 2px;\n\n    .galleryMobile__socialsSpacer {\n        width: 100vw;\n        height: 45px;\n    }\n\n    .galleryMobile__imageContainer {\n\n        .galleryMobile__imageLoading {\n            width: calc(100vw - 30px);\n            height: 100vw;\n            margin-top: 15px;\n            color: white;\n            text-align: center;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            border: 1px solid rgba(255,255,255,.2);\n        }\n\n        .galleryMobile__imageError {\n            font-size: 32px;\n            color: firebrick;\n            width: calc(100vw - 30px);\n            height: 100vw;\n            margin-top: 15px;\n            text-align: center;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            background-color: rgba(255,255,255,.1);\n            border: 1px solid rgba(255,255,255,.2);\n            .galleryMobile__textError{\n                color: white;\n                margin-top: 10px;\n                width: 150px;\n                font-size: 12px;\n                font-weight: 300;\n                letter-spacing: 5px;\n                opacity: .75;\n            }\n        }\n\n        .galleryMobile__image {\n            width: calc(100vw - 30px);\n            height: 100vw;\n            margin-top: 15px;\n            opacity: 1;\n            object-fit: cover;\n            object-position: 100% center;\n            cursor: pointer;\n            transition: height .6s ease, opacity .6s ease, margin .6s ease;\n        }\n\n        .galleryMobile__imageSensible {\n            margin: 0;\n            height: 0;\n            opacity: 0;\n            transition: height .6s ease, opacity .6s ease, margin .6s ease;\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
